export const clearLocalStorage = () => {
  const utm = localStorage.getItem("utm");
  localStorage.clear();
  if (utm) {
    localStorage.setItem("utm", utm);
  }
};
